import React, {useEffect, useMemo} from "react";
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid
} from "@mui/material";
import {iEnrollment} from "../../types/iEnrollment";
import {useForm} from "react-hook-form";
import {DatePickerElement, SelectElement, TextFieldElement} from "react-hook-form-mui";
import {RootState} from "../../store/reducers";
import {useDispatch, useSelector} from "react-redux";
import {getEstruturaLevelDisciplinas} from "../../store/actions/estruturaDiscActions";
import {situacaoMatricula, situacaoMatriculaSecretaria} from "../../utils/utility";
import {useYupValidationResolver} from "../../utils/utils";
import * as yup from "yup";
import {postAddMatricula} from "../../store/actions/alunosActions";
import {enrollmentLevelSchema} from "../../utils/enrollmentValidation";
import { sharedStyles } from "./alunoDialogStyles";


const sxStyles = {
    mainGrid: {
        ...sharedStyles.containerRow,
        marginBottom: '15px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: '8px',
        p:3
    },
    fieldGrid: sharedStyles.fieldGrid,
    discGrid: sharedStyles.containerRowNoWrap,
}

interface iAlunoEnrollmentDialog  {
    registro: iEnrollment,
    aluno: any,
    isOpen: boolean,
    dialogState: (param:boolean) => void,
}


const yupSchema = yup.object().shape({
    Level_id: enrollmentLevelSchema,
    dhDate: yup.date().required("Classe e obrigatoria"),
    dhExpireDate: yup.date().required("Disciplinas sao obrigatorias"),
    ValorParcela: yup.number().required("Valor da parcela e obrigatorio"),
    NumberOfInstallments: yup.number().min(0).max(40).required("Numero de parcelas e obrigatorio"),
    dhVecto1aParcela: yup.date().required("Data da 1a parcela e obrigatoria"),
});

const AlunoEnrollmentDialog = ({ registro,  aluno, isOpen, dialogState  } : iAlunoEnrollmentDialog ) => {
    const dataNiveis = useSelector((state: RootState) => state.cadastros.estruturaDisciplinas);
    const dataN = useMemo<{id: number; label: string}[]>(() => dataNiveis
        .filter((item: any) => item.isActive && Number.isSafeInteger(Number(item.id)) && Number(item.id) > 0)
        .map((item: any) => ({id: Number(item.id), label: item.Description})), [dataNiveis]);
    const validationSchema = useMemo(() => yupSchema.shape({
        Level_id: enrollmentLevelSchema.oneOf(dataN.map((item) => item.id), 'Selecione um nível disponível'),
    }), [dataN]);
    const resolver = useYupValidationResolver(validationSchema);
    const { control, handleSubmit, setError, formState: { isDirty, isSubmitting, errors } } =
        useForm<iEnrollment>(
        {
            resolver: resolver,
            mode: 'all',
            reValidateMode: 'onChange',
                defaultValues:  useMemo(() => {

                  return { ...registro, Level_id: registro.Level_id > 0 ? registro.Level_id : undefined }
                }, [registro])
        });

    const dispatch = useDispatch<any>();


    useEffect(() => {
        if (dataNiveis.length === 0) {
            dispatch(getEstruturaLevelDisciplinas());
        }

    },[dataNiveis.length, dispatch]);



    const handleClose = () => {
        if (!isSubmitting) dialogState(false);
    }

    const onSubmit = async (data: any) => {
        try {
            const saved = await dispatch(postAddMatricula(aluno.id, data));
            if (saved) {
                dialogState(false);
            } else {
                setError('root', {message: 'O aluno mudou. Reabra o cadastro da matrícula.'});
            }
        } catch (error: any) {
            setError('root', {message: error.response?.data?.error?.message || error.message || 'Não foi possível salvar a matrícula.'});
        }
    }

    return (<React.Fragment>

            <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth={"lg"}>
                <form
                    onSubmit={handleSubmit(onSubmit)}
                >
                <DialogTitle>Nova Matricula</DialogTitle>
                <DialogContent>
                    {errors.root?.message && <Alert severity="error">{errors.root.message}</Alert>}
                    <DialogContentText component="div">
                        <Grid item container sx={{...sxStyles.mainGrid, p:3}} sm={12} md={12} lg={12} xl={12}>

                            <Grid item container sx={{...sxStyles.fieldGrid, justifyContent: 'space-between'}} sm={12} md={12} lg={12} xl={12}>
                                <Grid item container sx={{...sxStyles.fieldGrid}} sm={6} md={6} lg={6} xl={6}>

                                    <SelectElement
                                        control={control}
                                        label="NIVEL"
                                        name="Level_id"
                                        type={'number'}
                                        options={dataN}
                                        fullWidth={true}
                                        required={true}

                                    />
                                </Grid>

                            </Grid>
                            <Grid item container sx={{...sxStyles.fieldGrid}} sm={12} md={12} lg={4} xl={4}>
                                <DatePickerElement
                                    control={control}
                                    label="DATA MATRICULA."
                                    name="dhDate"
                                    required

                                />
                            </Grid>
                            <Grid item container sx={{...sxStyles.fieldGrid}} sm={12} md={12} lg={4} xl={4}>
                                <DatePickerElement
                                    control={control}
                                    label="VENCIMENTO MATRICULA."
                                    name="dhExpireDate"
                                    required
                                />
                            </Grid>


                            <Grid item container sx={{...sxStyles.fieldGrid, justifyContent: 'space-between', marginTop: '3px'}} sm={12} md={12} lg={12} xl={12}>
                                <Grid item container sx={{...sxStyles.fieldGrid}} sm={12} md={12} lg={4} xl={4}>
                                    <TextFieldElement
                                        control={control}
                                        type={'number'}
                                        margin={'none'}
                                        label={'VALOR PARCELA'}
                                        name={'ValorParcela'}
                                        fullWidth={true}
                                        required
                                    />
                                </Grid>
                                <Grid item container sx={{...sxStyles.fieldGrid}} sm={12} md={12} lg={4} xl={4}>
                                    <TextFieldElement
                                        control={control}

                                        margin={'none'}
                                        label={'# PARCELAS'}
                                        name={'NumberOfInstallments'}
                                        fullWidth={true}
                                        required
                                    />
                                </Grid>
                                <Grid item container sx={{...sxStyles.fieldGrid}} sm={12} md={12} lg={4} xl={4}>
                                    <DatePickerElement
                                        control={control}

                                        label="VENCIMENTO 1a PARCELA"
                                        name="dhVecto1aParcela"
                                        required

                                    />
                                </Grid>
                            </Grid>


                            <Grid item container sx={{...sxStyles.fieldGrid}} sm={12} md={12} lg={12} xl={12}>
                                <TextFieldElement
                                    control={control}

                                    margin={'dense'}
                                    label={'COMENTARIOS'}
                                    name={'Comment'}
                                    fullWidth={true}
                                />
                            </Grid>

                            <Grid item container sx={{...sxStyles.fieldGrid, justifyContent: 'space-between'}} sm={12} md={12} lg={12} xl={12}>
                                <Grid item container sx={{...sxStyles.fieldGrid}} sm={12} md={12} lg={3} xl={3}>
                                    <SelectElement
                                        control={control}
                                        required={true}
                                        label="SITUACAO"
                                        name="Status"
                                        options={situacaoMatricula}
                                        fullWidth={true}
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid item container sx={{...sxStyles.fieldGrid}} sm={12} md={12} lg={2} xl={2}>
                                    <SelectElement
                                        control={control}
                                        required={true}
                                        label="SECRETARIA"
                                        name="Status"
                                        options={situacaoMatriculaSecretaria}
                                        fullWidth={true}
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid item container sx={{...sxStyles.fieldGrid}} sm={12} md={12} lg={2} xl={2}>
                                    <TextFieldElement
                                        control={control}
                                        margin={'dense'}
                                        label={'CARNE'}
                                        name={'PaymentCard'}
                                        fullWidth={true}
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid item container sx={{...sxStyles.fieldGrid}} sm={12} md={12} lg={2} xl={2}>
                                    <TextFieldElement
                                        control={control}

                                        margin={'dense'}
                                        label={'USUARIO VENDAS'}
                                        name={'UsuarioFezMatricula'}
                                        fullWidth={true}
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid item container sx={{...sxStyles.fieldGrid}} sm={12} md={12} lg={2} xl={2}>
                                    <TextFieldElement
                                        control={control}

                                        margin={'dense'}
                                        label={'USUARIO SECRETARIA'}
                                        name={'UsuarioFezRevisao'}
                                        fullWidth={true}
                                        disabled={true}
                                    />
                                </Grid>
                            </Grid>


                        </Grid>

                    </DialogContentText>
                    <DialogActions>
                        { isDirty &&
                            <Button type={'submit'} disabled={isSubmitting}>NOVO/SALVAR</Button>

                        }
                        <Button onClick={handleClose} disabled={isSubmitting}>Fechar</Button>
                    </DialogActions>

                </DialogContent>
                </form>
            </Dialog>


    </React.Fragment>);
}
export default (AlunoEnrollmentDialog);
